import {Loader as MantineLoader} from '@mantine/core';

/**
 * Loading spinner — design-layer pass-through over Mantine `Loader`.
 * @registry Pass-through Mantine Loader; import this instead of @mantine/core outside src/design.
 */
export const Loader = MantineLoader;
